export const PAYMENT_METHOD = {
  BANK_TRANSFERS: 'BankTransfers',
  CARD: 'Card',
  POST_PAID: 'PostPaid',
}

export const BANK_TRANSFER_TYPE = {
  ONE_PAY_ONLINE: 'OnePayOnline',
}

export const TYPE_TRANSFER = {
  VND: 'VND',
  USD: 'USD',
}

export const INVOICE_RECEIVE_FIELDS = {
  CUSTOMER_NAME: 'customerName',
  COMPANY_NAME: 'companyName',
  COMPANY_ADDRESS: 'companyAddress',
  TAX_CODE: 'taxCode',
  EMAIL: 'invoiceReceivingEmail',
  PHONE: 'phone',
}

export const IS_VALID_FIELDS = Object.assign(
  {},
  ...Object.values(INVOICE_RECEIVE_FIELDS).map((item) => ({ [item]: true })),
)

export const INFORMATION_INPUTS = [
  {
    key: INVOICE_RECEIVE_FIELDS.CUSTOMER_NAME,
    placeHolder: 'userManagement.paymentInformation.CUSTOMER_NAME',
  },
  {
    key: INVOICE_RECEIVE_FIELDS.COMPANY_NAME,
    placeHolder: 'userManagement.paymentInformation.COMPANY_NAME',
  },
  {
    key: INVOICE_RECEIVE_FIELDS.COMPANY_ADDRESS,
    placeHolder: 'userManagement.paymentInformation.COMPANY_ADDRESS',
  },
  {
    key: INVOICE_RECEIVE_FIELDS.TAX_CODE,
    placeHolder: 'userManagement.paymentInformation.TAX_CODE',
  },
  {
    key: INVOICE_RECEIVE_FIELDS.EMAIL,
    placeHolder: 'userManagement.paymentInformation.INVOICE_EMAIL',
  },
  {
    key: INVOICE_RECEIVE_FIELDS.PHONE,
    placeHolder: 'userManagement.paymentInformation.PHONE',
  },
]
